/**
 * cbpAnimatedHeader.js v1.0.0
 * http://www.codrops.com
 *
 * Licensed under the MIT license.
 * http://www.opensource.org/licenses/mit-license.php
 *
 * Copyright 2013, Codrops
 * http://www.codrops.com
 */
(function($) {
  $(function(){
    if (!Modernizr.touch) {
      var cbpAnimatedHeader = (function() {

        var docElem = document.documentElement,
          header = document.querySelector( '.cbp-af-header' ),
          didScroll = false,
          changeHeaderOn = 150;

        function init() {
          window.addEventListener( 'scroll', function( event ) {
            if( !didScroll ) {
              didScroll = true;
              setTimeout( scrollPage, 250 );
            }
          }, false );
        }

        function scrollPage() {
          var sy = scrollY();
          if ( sy >= changeHeaderOn ) {
            classie.add( header, 'cbp-af-header-shrink' );
          }
          else {
            classie.remove( header, 'cbp-af-header-shrink' );
          }
          didScroll = false;
        }

        function scrollY() {
          return window.pageYOffset || docElem.scrollTop;
        }

      init();
      })();
    }
  });
})(jQuery);
